import React, { useEffect, useRef } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import MobileNav from "../Mobilenav";
import { useLocation } from "react-router-dom";

interface HorizontalLayoutProps {
  children: React.ReactNode;
  showNav?: boolean;
  isLoading?: boolean;
  isBusy?: boolean;
}

const HorizontalLayout: React.FC<HorizontalLayoutProps> = ({
  children,
  showNav = true,
  isLoading = false,
  isBusy = false,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, [location.pathname]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        background: "#f1f6ff",
      }}
    >
      <Header />
      <div style={{ display: "flex", flex: "1 1 auto" }}>
        {showNav && <Sidebar />}
        <div
          style={{
            position: "relative",
            flex: "1 1 auto",
            minWidth: 0,
            height: "calc(100vh - 82px)",
            overflowY: "auto",
          }}
          ref={contentRef}
        >
          {!isLoading && children}

          {isBusy && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: "rgba(255,255,255,0.8)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
                fontFamily: "var(--font-primary)",
                fontSize: 16,
                color: "#26295e",
                fontWeight: 600,
              }}
            >
              <div style={{ textAlign: "center" }}>
                <div
                  style={{
                    width: 40,
                    height: 40,
                    border: "3px solid #3b519c",
                    borderTopColor: "transparent",
                    borderRadius: "50%",
                    animation: "spin 0.8s linear infinite",
                    margin: "0 auto 16px",
                  }}
                />
                We are submitting your changes.
              </div>
            </div>
          )}
        </div>
      </div>
      {showNav && <MobileNav />}
    </div>
  );
};

export default HorizontalLayout;
